import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { AppConfig } from '../../providers/config';
import { AppVersion } from '@ionic-native/app-version';
import { AuthProvider } from '../../providers/auth/auth';
import { TranslateService } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';

@IonicPage()
@Component({
    selector: 'page-settings',
    templateUrl: 'settings.html',
})
export class SettingsPage {
    displayName: string;
    branchName: string;
    versionNumber: any;
    userPicture: string;
    environment: string;
    language: string;
    followup: number = 10;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public auth: AuthProvider,
        private appVersion: AppVersion,
        private platform: Platform,
        private translateService: TranslateService,
        private storage: Storage) {

        this.environment = AppConfig.constants.ENVIRONMENT;
        this.displayName = AppConfig.Global.profile.email;
        this.language = AppConfig.Global.profile.Language;

        if (this.platform.is('cordova')) {
            // You are on a device, cordova plugins are accessible
            this.appVersion.getVersionNumber().then((version) => {
                console.log(version);
                this.versionNumber = version;
            });
        } else {
            // Cordova not accessible, add mock data if necessary
            this.versionNumber = AppConfig.constants.MOCK_VERSION;
            console.log("Cordova not accessible " + this.versionNumber);
        }
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad SettingsPage');
    }

    changeLanguage($event){
        //this.auth.setLanguage($event).then(() => {
        //    this.language = $event;
        //    this.translateService.use(this.language);
            //this.storage.set(AppConfig.Global.client_id + '_profile', JSON.stringify(AppConfig.Global.profile)).then(() => {
            //    AppConfig.Global.profile.Language = this.language;
            //});
       // });
    }

    changeFollowUp($event)  {
        console.log($event);
    }

    logOut() {
        this.auth.logout();
    }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts